import { MomentFormatSpecification } from 'moment';
import { freeze } from '@trello/objects';

/**
 * Somewhat different from app/scripts/debug/constants.ts::Feature; these are
 * all features that have some rollout configuration defined for the sake of
 * in-app "new" messaging.
 */
export type NewFeature =
  | 'AdminInsightsLink'
  | 'BoardBkgdGradients'
  | 'PupHeaderHub'
  | 'WorkspaceViewSpotlightExperience'
  // Not a real feature; used exclusively for unit tests. Do not sort!
  | 'TestFeature';

export const MOMENT_FORMAT: MomentFormatSpecification = 'MM-DD-YYYY';
// Mirrors MOMENT_FORMAT.
type DateStringFormat = `${number}-${number}-${number}`;

type ConfigType = Record<
  NewFeature,
  [release: DateStringFormat, expiration: DateStringFormat]
>;

export const FeatureRolloutConfig = freeze<ConfigType>({
  AdminInsightsLink: ['12-01-2021', '05-01-2022'],
  BoardBkgdGradients: ['03-01-2021', '06-01-2021'],
  PupHeaderHub: ['12-06-2021', '02-01-2022'],
  // Following the internal release date for WSV 2.0 as mentioned here:
  // https://hello.atlassian.net/wiki/spaces/TRELLO/pages/1247200437/Release+Plan+WSViews+2.0+Dec+2021
  WorkspaceViewSpotlightExperience: ['11-15-2021', '07-01-2023'],

  // Defined exclusively for unit tests; don't sort this.
  TestFeature: ['01-01-2021', '01-01-9999'],
});
